import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, Platform, ToastController, LoadingController } from 'ionic-angular';
import { API } from "../../services/api/api.services";
import { pouchdb, iDesignacionesAPI } from "../../services/pouchdb/pouchdb.service";
import { BasePage } from "../../models/basePage";
import { SignatureComponent } from "../../components/signature/signature";
import { Designaciones_Firmas } from '../../models/designaciones';
import { PopoverController } from 'ionic-angular/components/popover/popover-controller';
import { Popover } from 'ionic-angular/components/popover/popover';
import { MenuDerechoComponent } from '../../components/menu-derecho/menu-derecho';
import { ActionSheetController } from 'ionic-angular/components/action-sheet/action-sheet-controller';
import { ActionSheet } from 'ionic-angular/components/action-sheet/action-sheet';
import { CustodiaPage } from '../custodia/custodia';
import { Http } from "@angular/http";

@IonicPage()
@Component({
  selector: 'page-firmas',
  templateUrl: 'firmas.html',
})
export class FirmasPage extends BasePage {

  private esEquipoLocal: boolean;
  private tipoFirma: string;
  private firma: string;
  private idLicencia: number = 0;        // Identificador de la licencia que está relacionada con la persona

  // Acceso al componente Signature
  @ViewChild(SignatureComponent)
  private signatureComponent: SignatureComponent;

  constructor(public navCtrl: NavController, public platform: Platform, public http: Http, public toastCtrl: ToastController, public DBService: pouchdb.DBService, public navParams: NavParams, public Params: API.ParametrosAlineacion, public menuCtrl: MenuController, public SessionService: API.SessionService, private popOverCtrl: PopoverController, private actionSheetCtrl: ActionSheetController, public loadingCtrl: LoadingController) {
    super(navCtrl, platform, http, toastCtrl, DBService, loadingCtrl);
  }

  ionViewDidLoad() {
    this.platform.ready()
      .then(() => {
        this.MostrarCarga();
        return this.ObtenerDesignacion(this.SessionService.getUsuario().idUsuario, parseInt(this.navParams.get("idDesignacion")))
      })
      .then((resultado: iDesignacionesAPI) => {
        this.designacion = resultado;
        this.esEquipoLocal = this.EsEquipoLocal(resultado, parseInt(this.navParams.get("idEquipo")));
        this.tipoFirma = this.navParams.get("tipo");

        this.FirmaDeLaPersona();
        this.OcultarCarga();
      })
      .catch((error) => {
        this.Error(JSON.stringify(error), "firmas", "onViewDidLoad", 'ERROR: Obteniendo los datos de la designación: ' + this.navParams.get("idDesignacion"));
      });
  }

  // #region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(MenuDerechoComponent, {
      primeraParte: true
    });

    popover.present({
      ev: event
    });
  }

  /**
   * Elimina la firma, tanto del canvas como de la designación
   */
  public EliminarFirma(): void {
    this.signatureComponent.signaturePad.clear();
    this.firma = "";

    this.designacion.partido.listaFirmas.forEach((valor: Designaciones_Firmas, i: number) => {
      if (valor.idJugador == this.idLicencia) {
        this.designacion.partido.listaFirmas.splice(i, 1);

        this.GuardarLog(JSON.stringify(valor), "firmas", "EliminarFirma", "Firma eliminada de la designación: " + this.designacion.id_Designacion);
      }
    });
    this.GuardarDesignacionV2("eliminar");
  }

  /**
   * Comprueba si la persona ya tiene una firma guardada, para inicializar el cuadro de firmas con ella.
   */
  private FirmaDeLaPersona(): void {
    this.firma = "";

    switch (this.tipoFirma) {
      case "C":
        if (this.esEquipoLocal) {
          this.idLicencia = this.designacion.partido.idCapitanLocal;
        }
        else {
          this.idLicencia = this.designacion.partido.idCapitanVisitante;
        }
        break;

      case "D":
        if (this.esEquipoLocal) {
          this.idLicencia = this.designacion.partido.idDelegadoLocal;
        }
        else {
          this.idLicencia = this.designacion.partido.idDelegadoVisitante;
        }
        break;

      case "E":
        if (this.esEquipoLocal) {
          this.idLicencia = this.designacion.partido.idEntrenadorLocal;
        }
        else {
          this.idLicencia = this.designacion.partido.idEntrenadorVisitante;
        }
        break;

      case "A":
        this.idLicencia = this.designacion.partido.idDelegadoCampo;
        break;
    }

    if (this.designacion.partido.listaFirmas != null && this.designacion.partido.listaFirmas.length > 0) {
      this.designacion.partido.listaFirmas.forEach((valor: Designaciones_Firmas, i: number) => {
        if (valor.idJugador == this.idLicencia) {
          this.firma = valor.firma;
        }
      });
    }
  }

  public FirmaInicializada($event: boolean): void {
    this.signatureComponent.signaturePad.fromDataURL(this.firma);
  }

  /**
   * Guardado de los datos de la designación
   */
  public GuardarDesignacionV2(operacion: string): void {
    // Guardado de los datos de la designación
    this.DBService.DesignacionesUpdate(this.designacion)
      .then((resultado: PouchDB.Core.Response) => {
        if (resultado.ok) {
          this.designacion._id == resultado.id;
          this.designacion._rev = resultado.rev;

          if (operacion == "guardar") {
            this.Mensaje("Se ha GUARDADO correctamente la firma", "green-sea", 3000);
            this.GuardarLog(JSON.stringify(this.designacion), "firmas", "GuardarDesignacionV2", "Designación guardada: " + this.designacion.id_Designacion);
          }
          else {
            this.Mensaje("Se ha ELIMINADO correctamente la firma", "danger", 3000);
            this.GuardarLog(JSON.stringify(this.designacion), "firmas", "GuardarDesignacionV2", "Firma eliminada de la designación: " + this.designacion.id_Designacion);
          }
        }
      })
      .catch((error) => this.Error(JSON.stringify(error), "firmas", "GuardarDesignacionV2", "ERROR: Guardando los datos de la designación: " + this.designacion.id_Designacion));
  }

  /**
   * Guarda la firma de la persona actual en la tramitación
   */
  public GuardarFirma(): void {
    this.firma = this.signatureComponent.signaturePad.toDataURL("image/png");
    // Primero, se comprueba si no se ha firmado
    if (this.firma.trim().length == 0) {
      this.Mensaje("No se ha detectado ninguna firma. No se puede guardar.", "", 6000);
    }
    else {
      let encontrada: boolean = false;

      this.designacion.partido.listaFirmas.forEach((valor: Designaciones_Firmas, i: number) => {
        if (valor.idJugador == this.idLicencia) {
          encontrada = true;
          valor.firma = this.firma;
          this.designacion.partido.listaFirmas.splice(i, 1, valor);
        }
      });

      if (!encontrada) {
        let nuevaFirma: Designaciones_Firmas = {
          esLocal: this.esEquipoLocal,
          firma: this.firma,
          idJugador: this.idLicencia,
          tipoJugador: this.tipoFirma
        };

        console.log("--- FIRMA A GUARDAR ---");
        console.log(nuevaFirma);

        this.designacion.partido.listaFirmas.push(nuevaFirma);

        this.GuardarLog(JSON.stringify(nuevaFirma), "firmas", "GuardarFirma", "Firma guardada de la designación: " + this.designacion.id_Designacion);
      }

      // Guardado de la firma en la designación
      this.GuardarDesignacionV2("guardar");
    }
  }

  public NombreFirmante(): string {
    let resultado: string = "";

    if (this.tipoFirma != undefined && this.tipoFirma.trim().length > 0) {
      switch (this.tipoFirma) {
        case "C":
          // Capitán
          if (this.esEquipoLocal) {
            resultado = "Capitán local: " + this.NombreCompletoPersona(this.designacion.partido.idCapitanLocal, true);
          }
          else {
            resultado = "Capitán visitante: " + this.NombreCompletoPersona(this.designacion.partido.idCapitanVisitante, false);
          }
          break;

        case "D":
          // Delegado
          if (this.esEquipoLocal) {
            resultado = "Delegado local: " + this.NombreCompletoPersona(this.designacion.partido.idDelegadoLocal, true);
          }
          else {
            resultado = "Delegado visitante: " + this.NombreCompletoPersona(this.designacion.partido.idDelegadoVisitante, false);
          }
          break;

        case "E":
          // Entrenador
          if (this.esEquipoLocal) {
            resultado = "Entrenador local: " + this.NombreCompletoPersona(this.designacion.partido.idEntrenadorLocal, true);
          }
          else {
            resultado = "Entrenador visitante: " + this.NombreCompletoPersona(this.designacion.partido.idEntrenadorVisitante, false);
          }
          break;

        case "A":
          // Delegado de campo
          resultado = "Delegado de campo: " + this.NombreCompletoPersona(this.designacion.partido.idDelegadoCampo, true);
          break;
      }
    }

    return resultado;
  }

  public Siguiente(): void {
    if (this.idLicencia > 0 && this.firma.trim().length == 0) {
      let action: ActionSheet = this.actionSheetCtrl.create({
        title: "Sin firma",
        subTitle: "No se ha establecido la firma. ¿Desea continuar?",
        buttons: [
          {
            text: 'OK',
            handler: () => {
              this.SiguienteConfirmado();
            }
          }, {
            text: 'Cancelar',
            role: 'cancel'
          }
        ]
      });
      action.present();
    }
    else {
      this.SiguienteConfirmado();
    }
  }

  public SiguienteConfirmado(): void {
    switch (this.tipoFirma) {
      case "C":
        if (this.esEquipoLocal) {
          this.navCtrl.push(FirmasPage, {
            idDesignacion: this.designacion.id_Designacion,
            idEquipo: this.designacion.idEquipoLocal,
            tipo: "E"
          });
        }
        else {
          this.navCtrl.push(FirmasPage, {
            idDesignacion: this.designacion.id_Designacion,
            idEquipo: this.designacion.idEquipoVisitante,
            tipo: 'E'
          });
        }
        break;

      case "E":
        if (this.esEquipoLocal) {
          this.navCtrl.push(FirmasPage, {
            idDesignacion: this.designacion.id_Designacion,
            idEquipo: this.designacion.idEquipoVisitante,
            tipo: "C"
          });
        }
        else {
          this.navCtrl.push(FirmasPage, {
            idDesignacion: this.designacion.id_Designacion,
            idEquipo: this.designacion.idEquipoLocal,
            tipo: 'A'
          });
        }
        break;

      case "A":
        // Se comprueba que las alineaciones están confirmadas
        if (this.AlineacionesConfirmadas(this.designacion)) {
          this.navCtrl.push(CustodiaPage, {
            idDesignacion: this.designacion.id_Designacion
          });
        }
        else {
          this.Mensaje('No se puede ir al siguiente paso porque las alineaciones no están confirmadas.', '', 6000);
        }
        break;
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/firmas/firmas.ts